import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';

interface ICheckboxFieldProps {
	id: string;
	formik: any;
	textLabel: string;
	disabled?: boolean;
}

const CheckboxField: React.FC<ICheckboxFieldProps> = ({
	id,
	formik,
	textLabel,
	disabled
}) => (
	<FormControlLabel
		id={id}
		label={textLabel}
		control={
			<Checkbox
				id={id}
				data-testid={`checkbox-field-${id}`}
				checked={formik.values[id]}
				onChange={() => formik.setFieldValue(id, !formik.values[id])}
				disabled={disabled}
			/>
		}
	/>
);

CheckboxField.defaultProps = {
	disabled: false
};

export default CheckboxField;
